import styled from 'styled-components';
import { spacingOptions } from '../utils/utils';

const Section = styled.section`
	padding: ${props => props.theme.spacing}rem 0;
	${spacingOptions}
`;

export {
	Section
};
